// 颜色选项配置
export const colorOptions = [
  { id: 13, color: 'transparent', displayName: '透明' },
  { id: 14, color: 'white', displayName: '白色' },
  { id: 1, color: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)', displayName: '粉红' },
  { id: 2, color: 'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)', displayName: '天蓝' },
  { id: 3, color: 'linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)', displayName: '薄荷' },
  { id: 4, color: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)', displayName: '橙橘' },
  { id: 5, color: 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)', displayName: '紫粉' },
  { id: 6, color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', displayName: '玫红' },
  { id: 7, color: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', displayName: '蓝绿' },
  { id: 8, color: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', displayName: '绿色' },
  { id: 9, color: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', displayName: '红黄' },
  { id: 10, color: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)', displayName: '深蓝' },
  { id: 11, color: 'linear-gradient(135deg, #ff3019 0%, #c90477 100%)', displayName: '红紫' },
  { id: 12, color: 'linear-gradient(135deg, #7028e4 0%, #e5b2ca 100%)', displayName: '紫粉' },
  { id: 15, color: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)', displayName: '暖阳' },
  { id: 16, color: 'linear-gradient(135deg, #5ee7df 0%, #b490ca 100%)', displayName: '清新' },
  { id: 17, color: 'linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)', displayName: '梦幻' },
  { id: 18, color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', displayName: '星空' },
  { id: 19, color: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)', displayName: '樱花' },
  { id: 20, color: 'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)', displayName: '天空' },
  { id: 21, color: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)', displayName: '金橙' }
];

/**
 * 获取随机渐变颜色（不包括透明和白色）
 * @returns {string} 随机渐变颜色CSS值
 */
export const getRandomColor = () => {
  const colorOptionsWithoutTransparent = colorOptions.filter(option => option.id !== 13 && option.id !== 14);
  const randomIndex = Math.floor(Math.random() * colorOptionsWithoutTransparent.length);
  return colorOptionsWithoutTransparent[randomIndex].color;
};

/**
 * 根据颜色ID获取颜色值
 * @param {number} id - 颜色ID
 * @returns {string|null} 颜色CSS值，如果未找到返回null
 */
export const getColorById = (id) => {
  const colorOption = colorOptions.find(option => option.id === id);
  return colorOption ? colorOption.color : null;
};

/**
 * 根据颜色值获取颜色配置
 * @param {string} color - 颜色CSS值
 * @returns {object|null} 颜色配置对象，如果未找到返回null
 */
export const getColorOptionByValue = (color) => {
  return colorOptions.find(option => option.color === color) || null;
}; 